export default __webpack_public_path__ + "static/revanth_periyasamy-924dc6640f7fe852633f6180422d0db5.png";